import request from "./../utils/request";
import log2 from "../utils/log2";

const log = log2("WEBPHONE_NETGSM_API");

export const WEBPHONE_NETGSM_API = {
    extensions: {
        /**
         * Dahilileri listeler
         * @param {string} extension - Belirli bir dahili araması için (isteğe bağlı)
         * @returns {Promise<Array>} - Dahili listesi
         */
        list: (extension = "") => {
            log("extensions.list", { extension });
            return request({
                url: `/webphone/netgsm/extensions/list`,
                method: "get",
                params: { extension },
            }).then((response) => response.data);
        },

        /**
         * Belirli bir dahiliyi getirir
         * @param {string} extension - Dahili numarası
         * @returns {Promise<object>} - Dahili bilgileri
         */
        get: (extension) => {
            log("extensions.get", { extension });
            return request({
                url: `/webphone/netgsm/extensions/${extension}`,
                method: "get",
            }).then((response) => response.data);
        },

    },

    webhooks: {
        /**
         * Webhook listesini getirir
         * @returns {Promise<Array>} - Webhook listesi
         */
        list: () => {
            log("webhooks.list");
            return request({
                url: `/webphone/netgsm/webhooks`,
                method: "get",
            }).then((response) => response.data);
        },

        /**
         * Webhook ekler veya günceller
         * @param {string} responseurl - Webhook URL'i
         * @param {string} urltoken - Webhook token'ı (isteğe bağlı)
         * @returns {Promise<object>} - Webhook ekleme sonucu
         */
        set: (responseurl, urltoken = "") => {
            log("webhooks.set", { responseurl, urltoken });
            return request
                .post(`/webphone/netgsm/webhooks`, {
                    responseurl,
                    urltoken,
                })
                .then((response) => response.data);
        },

        /**
         * Webhook siler
         * @returns {Promise<object>} - Webhook silme sonucu
         */
        delete: () => {
            log("webhooks.delete");
            return request({
                url: `/webphone/netgsm/webhooks`,
                method: "delete",
            }).then((response) => response.data);
        },
    },

    reports: {
        /**
         * CDR (Call Detail Record) kayıtlarını getirir
         * @param {object} filters - Filtreleme parametreleri
         * @returns {Promise<object>} - CDR kayıtları
         */
        getCDRList: (filters) => {
            log("reports.getCDRList", filters);
            return request.post(`/webphone/netgsm/reports/cdr`, filters).then((response) => response.data);
        },

        /**
         * Arama kaydı dosyasının URL'ini getirir
         * @param {object} params - Kayıt dosyası parametreleri
         * @returns {Promise<object>} - Kayıt dosyası bilgileri
         */
        getRecordingFile: (params) => {
            log("reports.getRecordingFile", params);
            return request.post(`/webphone/netgsm/reports/recording`, params).then((response) => response.data);
        },
    },

    calls: {
        /**
         * Arama başlatır
         * @param {object} callData - Arama parametreleri
         * @returns {Promise<object>} - Arama başlatma sonucu
         */
        make: (callData) => {
            log("calls.make", callData);
            return request.post(`/webphone/netgsm/calls/make`, callData).then((response) => response.data);
        },

        /**
         * Aramayı yönlendirir
         * @param {object} redirectData - Yönlendirme parametreleri
         * @returns {Promise<object>} - Yönlendirme sonucu
         */
        redirect: (redirectData) => {
            log("calls.redirect", redirectData);
            return request.post(`/webphone/netgsm/calls/redirect`, redirectData).then((response) => response.data);
        },

        /**
         * Aramayı sonlandırır
         * @param {string} uniqueid - Benzersiz arama ID'si
         * @returns {Promise<object>} - Sonlandırma sonucu
         */
        hangup: (uniqueid) => {
            log("calls.hangup", { uniqueid });
            return request.post(`/webphone/netgsm/calls/hangup`, { uniqueid }).then((response) => response.data);
        },
    },
};
